export default "__VITE_ASSET__CyBe33Av__"